import React from "react";

import Permission from "./Permission";

export default function Logout() {
  localStorage.clear();
  return <Permission />;
}
 